'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Heading;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _heading = require('./heading.css');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Heading(props) {
  var children = props.children,
      _props$color = props.color,
      color = _props$color === undefined ? 'navy700' : _props$color,
      _props$icon = props.icon,
      icon = _props$icon === undefined ? false : _props$icon,
      _props$size = props.size,
      size = _props$size === undefined ? 'small' : _props$size,
      iconAfter = props.iconAfter,
      _props$hover = props.hover,
      hover = _props$hover === undefined ? false : _props$hover,
      _props$iconPadding = props.iconPadding,
      iconPadding = _props$iconPadding === undefined ? 10 : _props$iconPadding,
      className = props.className,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'color', 'icon', 'size', 'iconAfter', 'hover', 'iconPadding', 'className']);


  return React.createElement(
    _text2.default,
    (0, _extends3.default)({
      size: size,
      interactive: hover === 'interactive',
      display: 'block',
      color: color,
      className: (0, _classnames2.default)(_heading2.default.root, className)
    }, otherProps),
    icon ? React.createElement(
      _icon2.default,
      {
        size: size === 'extra-large' ? 24 : 14,
        color: color,
        paddingRight: iconPadding
      },
      icon
    ) : null,
    children,
    iconAfter ? React.createElement(
      _icon2.default,
      {
        size: size === 'extra-large' ? 24 : 14,
        color: color,
        paddingLeft: iconPadding
      },
      iconAfter
    ) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/heading/heading.js
// module id = 332
// module chunks = 114276838955818